import {
  FILTER_EVENTS_BY_VENUE_ID,
  UPDATE_EVENTS_BY_VENUE_ID
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case FILTER_EVENTS_BY_VENUE_ID:
      return {
        ...state,
        ...action.payload
      }
    case UPDATE_EVENTS_BY_VENUE_ID:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
